export const GetLocations = (model) => {

  return $.get('Location/GetLocations')

}

export const GetPositions = (model) => {

  return $.get('Position/GetMinPositions?addOrEdit=edit&userBeingEditedId='+model) //FG - After Cert - First Release Security - added the addOrEdit Parameter

}
export const GetPersonnelSalaries = (personnelId) => {

  return $.get('Personnel/GetPersonnelSalaries?personnelId=' + personnelId)

}

export const GetMainUsers = () => {

  return $.get('Personnel/GetMainUsers')

}


export const UpdatePersonnelJobDetails = (model) => {

  return $.post('Personnel/UpdatePersonnelJobDetails',model)

}



// WEBPACK FOOTER //
// ./src/components/Jobdetails/Jobdetails.services.js